export * from './detail'
